class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
    });

    const fromSlider = document.querySelector('[data-target="min-price-range-filter"]');
    const toSlider = document.querySelector('[data-target="max-price-range-filter"]');
    this.fromInput = document.querySelector('[data-target="min-price-text-filter-display"]');
    this.toInput = document.querySelector('[data-target="max-price-text-filter-display"]');
    this.fromInputText = document.querySelector('[data-target="min-price-text-filter-display-span"]');
    this.toInputText = document.querySelector('[data-target="max-price-text-filter-display-span"]');
    this.fromInputHidden = document.querySelector('[data-target="min-price-text-filter"]');
    this.toInputHidden = document.querySelector('[data-target="max-price-text-filter"]');
    this.adaFromInput = document.querySelector('[data-target="min-price-ada-filter"]');
    this.adaToInput = document.querySelector('[data-target="max-price-ada-filter"]');
    this.increaseMaxRange = document.querySelector('[data-target="increase-max-range"]');
    this.decreaseMaxRange = document.querySelector('[data-target="decrease-max-range"]');
    this.decreaseMinRange = document.querySelector('[data-target="decrease-min-range"]');
    this.increaseMinRange = document.querySelector('[data-target="increase-min-range"]');
    this.fromRange =  fromSlider;
    this.toRange =  toSlider;


    this.fillSlider(fromSlider, toSlider, '#C6C6C6', '#000000', toSlider);
    this.setToggleAccessible(toSlider);

    fromSlider.oninput = () =>
      this.controlFromSlider(fromSlider, toSlider,
        this.fromInput, this.fromInputHidden,this.adaFromInput);
    toSlider.oninput = () =>
      this.controlToSlider(fromSlider, toSlider,
        this.toInput, this.toInputHidden,this.adaToInput);
    this.fromInput.oninput = () =>
      this.controlFromInput(fromSlider, this.fromInput,
        this.toInput, toSlider, this.fromInputHidden, 
        this.toInputHidden,this.adaFromInput);
    this.toInput.oninput = () =>
      this.controlToInput(toSlider, this.fromInput,
        this.toInput, toSlider, this.toInputHidden,this.adaToInput);

    this.increaseMaxRange.addEventListener('click',(e)=>{
        e.preventDefault();
        setTimeout(() => {
          this.adjustToValidValues(this.adaToInput,1);
          this.fillSlider(fromSlider, toSlider, '#C6C6C6', '#000000', toSlider);
        }, 500);
        
      })
    this.decreaseMaxRange.addEventListener('click',(e)=>{
        e.preventDefault();
        setTimeout(() => {
          this.adjustToValidValues(this.adaToInput,-1);
          this.fillSlider(fromSlider, toSlider, '#C6C6C6', '#000000', toSlider);
        }, 500);
        
      })
      this.increaseMinRange.addEventListener('click',(e)=>{
        e.preventDefault();
        setTimeout(() => {
          this.adjustToValidValues(this.adaFromInput,1);
          this.fillSlider(fromSlider, toSlider, '#C6C6C6', '#000000', toSlider);
        }, 500);
        
      })
      this.decreaseMinRange.addEventListener('click',(e)=>{
        e.preventDefault();
        setTimeout(() => {
          this.adjustToValidValues(this.adaFromInput,-1);
          this.fillSlider(fromSlider, toSlider, '#C6C6C6', '#000000', toSlider);
        }, 500);
        
      })
  }

  


  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
  }

  adjustToValidValues(input,direction) {
    
    const inputReceived = input;
    const value = Number(inputReceived.value);
    let inputValue = value;
    const min = Number(inputReceived.getAttribute('min'));
    const max = Number(inputReceived.getAttribute('max'));
    let minCompare = min;
    let maxCompare = max;
    const isRange = inputReceived.getAttribute('type') === 'range'
    const isStep = inputReceived.getAttribute('type') === 'number'

    if (isRange) {
      const toleranceMargins = Math.round(max * 0.005);
      minCompare += toleranceMargins;
      maxCompare -= toleranceMargins;
    }

    if (isStep) {
      const toleranceMargins = Number(inputReceived.getAttribute('step'));
      minCompare += toleranceMargins;
      maxCompare -= toleranceMargins;
      inputValue = Math.round(Number(value + (direction*toleranceMargins)))
      inputReceived.value = inputValue;

      if(inputReceived === this.adaToInput) {
        this.toInput.value = inputValue;
        this.toInputText.textContent = inputValue;
        this.toRange.value = inputValue;
        this.toInputHidden.value = inputValue;
      }

      if(inputReceived === this.adaFromInput) {
        this.fromInput.value = inputValue;
        this.fromInputText.textContent = inputValue;
        this.fromRange.value = inputValue;
        this.fromInputHidden.value = inputValue;
      }
      inputReceived.dispatchEvent(new Event('input', 
        { bubbles: true, cancelable: true }));
    }
  

    if (inputValue < minCompare) {
      inputReceived.value = min;
      if (isRange || isStep ) {
        this.fromInput.value = min;
        this.fromInputText.textContent = min;
      }
      this.fromInputHidden.value = '';
    }

    if (inputValue > maxCompare) {
      inputReceived.value = max;
      if (isRange || isStep) {
        this.toInput.value = max;
        this.toInputText.textContent = max;
      }
      this.toInputHidden.value = '';
    }
  }

  controlFromInput(fromSlider, fromInput, toInput,
    controlSlider, fromInputHidden,fromInputAda) {
    const controlFromSlider = fromSlider;
    const controlFromInput = fromInput;
    const controlFromInputHidden = fromInputHidden;
    const controlFromInputAda = fromInputAda;

    const [from, to] = this.getParsed(controlFromInput, toInput);
    this.fillSlider(controlFromInput, toInput, '#C6C6C6', '#000000', controlSlider);

    if (from > to) {
      controlFromSlider.value = to;
      controlFromInput.value = to;
      controlFromInputHidden.value = to;
      controlFromInputAda.value = to
    } else {
      controlFromSlider.value = from;
      controlFromInputHidden.value = from;
      controlFromInputAda.value = from
    }
  }

  // Double range inputs sync: 
  controlToInput(toSlider, fromInput, toInput, 
    controlSlider, toInputHidden,toInputAda) {
    const controlToSlider = toSlider;
    const controlToInput = toInput;
    const controlToInputHidden = toInputHidden;
    const controlToInputAda = toInputAda;

    const [from, to] = this.getParsed(fromInput, controlToInput);
    this.fillSlider(fromInput, controlToInput, '#C6C6C6', '#000000', controlSlider);
    this.setToggleAccessible(controlToInput);

    if (from <= to) {
      controlToSlider.value = to;
      controlToInput.value = to;
      controlToInputHidden.value = to;
      controlToInputAda.value = to
    } else {
      controlToInput.value = from;
      controlToInputHidden.value = from;
      controlToInputAda.value = from
    }
  }

  controlFromSlider(fromSlider, toSlider, fromInput, 
    fromInputHidden,fromInputAda) {
    const controlFromSlider = fromSlider;
    const controlFromInput = fromInput;
    const controlFromInputHidden = fromInputHidden;
    const controlFromInputAda = fromInputAda;

    const [from, to] = this.getParsed(fromSlider, toSlider);
    this.fillSlider(fromSlider, toSlider, '#C6C6C6', '#000000', toSlider);

    if (from > to) {
      controlFromSlider.value = to;
      this.fromInputText.textContent = to;
      controlFromInput.value = to;
      controlFromInputHidden.value = to;
      controlFromInputAda.value = to;
    } else {
      this.fromInputText.textContent = from;
      controlFromInput.value = from;
      controlFromInputHidden.value = from;
      controlFromInputAda.value = from;
    }
  }

  controlToSlider(fromSlider, toSlider, toInput, toInputHidden,toInputAda) {
    const controlToSlider = toSlider;
    const controlToInput = toInput;
    const controlToInputHidden = toInputHidden;
    const controlToInputAda = toInputAda;
    
    const [from, to] = this.getParsed(fromSlider, controlToSlider);
    this.fillSlider(fromSlider, controlToSlider, '#C6C6C6', '#000000', controlToSlider);
    this.setToggleAccessible(controlToSlider);

    if (from <= to) {
      controlToSlider.value = to;
      this.toInputText.textContent = to;
      controlToInput.value = to;
      controlToInputHidden.value = to;
      controlToInputAda.value = to;
    } else {
      this.toInputText.textContent = from;
      controlToInput.value = from;
      controlToInputHidden.value = from;
      controlToSlider.value = from;
      controlToInputAda.value = from;
    }
  }

  stringToNumberDecimals(val) {
    return parseFloat(parseFloat(val).toFixed(2))
  }

  getParsed(currentFrom, currentTo) {
    const from = this.stringToNumberDecimals(currentFrom.value);
    const to = this.stringToNumberDecimals(currentTo.value);

    return [from, to];
  }

  fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
    // The sliderColor is the unselected area background color 
    // The rangeColor is the selected area background color 
    const fillControlSlider = controlSlider;
    const rangeDistance = to.max - to.min;
    const fromPosition = from.value - to.min;
    const toPosition = to.value - to.min;
    fillControlSlider.style.background = `linear-gradient(
      to right,
      ${sliderColor} 0%,
      ${sliderColor} ${(fromPosition) / (rangeDistance) * 100}%,
      ${rangeColor} ${((fromPosition) / (rangeDistance)) * 100}%,
      ${rangeColor} ${(toPosition) / (rangeDistance) * 100}%, 
      ${sliderColor} ${(toPosition) / (rangeDistance) * 100}%, 
      ${sliderColor} 100%)`;
  }

  setToggleAccessible(currentTarget) {
    const toSlider = document.querySelector('[data-target="max-price-range-filter"]');
    if (Number(currentTarget.value) <= 0) {
      toSlider.style.zIndex = 2;
    } else {
      toSlider.style.zIndex = 0;
    }
  }
}

export default () => {
  if (!customElements.get('price-range'))
    customElements.define('price-range', PriceRange);
}